import { Range } from "immutable";

import { getAPI, deleteByKeyAPI, getAllAPI, createAPI } from "./api";
import { handleError, apiRequest } from "../lib/utils/request";
import { ValidationError } from "../../common/lib/validation";
import { setField } from "../../common/lib/redux-fields/actions";
import Alert from "react-s-alert";

export const GET_OFFERS = "GET_OFFERS";
export const GET_OFFERS_SUCCESS = "GET_OFFERS_SUCCESS";
export const GET_OFFERS_ERROR = "GET_OFFERS_ERROR";
export const GET_OFFERS_FINALLY = "GET_OFFERS_FINALLY";

export const GET_OFFER = "GET_OFFER";
export const GET_OFFER_SUCCESS = "GET_OFFER_SUCCESS";
export const GET_OFFER_ERROR = "GET_OFFER_ERROR";
export const GET_OFFER_FINALLY = "GET_OFFER_FINALLY";

export const DELETE_OFFER_BY_KEY = "DELETE_OFFER_BY_KEY";
export const DELETE_OFFER_BY_KEY_SUCCESS = "DELETE_OFFER_BY_KEY_SUCCESS";
export const DELETE_OFFER_BY_KEY_ERROR = "DELETE_OFFER_BY_KEY_ERROR";
export const DELETE_OFFER_BY_KEY_FINALLY = "DELETE_OFFER_BY_KEY_FINALLY";

export const SET_OFFER_PAGE = "SET_OFFER_PAGE";
export const SET_OFFER_SORT = "SET_OFFER_SORT";
export const SET_OFFER_SEARCH_FIELD = "SET_OFFER_SEARCH_FIELD";

export const CREATE_OFFER = "CREATE_OFFER";
export const CREATE_OFFER_SUCCESS = "CREATE_OFFER_SUCCESS";
export const CREATE_OFFER_ERROR = "CREATE_OFFER_ERROR";
export const CREATE_OFFER_FINALLY = "CREATE_OFFER_FINALLY";

export const OFFER_CLEAR_ERROR = "OFFER_CLEAR_ERROR";
export const OFFER_CLEAR_FORM = "OFFER_CLEAR_FORM";

export const GENERATE_OFFER_SEARCH_HASH = "GENERATE_OFFER_SEARCH_HASH";

const validateCreate = (validate, msg, fields) =>
  validate(fields)
    .prop("country")
    .required(msg["app.validation.required"])
    .prop("city")
    .required(msg["app.validation.required"])
    .prop("code")
    .required(msg["app.validation.required"])
    .prop("sex")
    .required(msg["app.validation.required"])
    .prop("title")
    .required(msg["app.validation.required"])
    .prop("startDate")
    .required(msg["app.validation.required"])
    .prop("agencyName")
    .required(msg["app.validation.required"])
    .prop("agencyEmail")
    .required(msg["app.validation.required"])
    .email("Wpisany email jest niepoprawny")
    .prop("agencyPhoneNumber")
    .required(msg["app.validation.required"])
    .prop("mainDesc")
    .required(msg["app.validation.required"])
    .prop("policy")
    .checked(msg["app.validation.policy"])
    .getErrors();

export const getAll = (page) => async (dispatch, getState, utils) => {
  let data = getState().offer.meta.toJS();
  const search = getState().offer.search.toJS();

  data.search = search;

  if (page !== "" && page !== undefined) {
    data.currentPage = page;
    data.offset = (data.currentPage - 1) * 10;
  }

  const action = GET_OFFERS;
  try {
    return await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      getAllAPI,
      data,
      null,
      (body) => {
        return new ValidationError("all", "");
      }
    );
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const get = (data) => async (dispatch, getState, utils) => {
  const action = GET_OFFER;
  try {
    return await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      getAPI,
      data,
      null,
      (body) => {
        return new ValidationError("all", "");
      }
    );
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const getByKey = (data) => async (dispatch, getState, utils) => {
  const action = GET_OFFER_BY_KEY;
  try {
    return await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      getByKeyAPI,
      data,
      null,
      (body) => {
        return new ValidationError("all", "");
      }
    );
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const setPage = (page, onlySet) => async (dispatch, getState, utils) => {
  dispatch({
    type: SET_OFFER_PAGE,
    payload: { page },
  });

  if (onlySet === undefined) {
    dispatch(getAll());
  }
};

export const setSort = (field, dir) => async (dispatch, getState, utils) => {
  dispatch({
    type: SET_OFFER_PAGE,
    payload: { page: 1 },
  });

  dispatch({
    type: SET_OFFER_SORT,
    payload: { field, dir },
  });

  dispatch(getAll());
};

export const setSearchField = (field, value) => async (
  dispatch,
  getState,
  utils
) => {
  dispatch({
    type: SET_OFFER_SEARCH_FIELD,
    payload: { field, value },
  });
};

export const create = (data) => async (dispatch, getState, utils) => {
  const action = CREATE_OFFER;

  try {
    return await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      validateCreate,
      createAPI,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
      (body) => {
        Alert.error(
          "Wystąpił błąd przy dodawaniu ogłoszenia! Spróbuj ponownie później lub skontaktuj się z nami pod adresem support@opiekujsie.pl",
          {
            position: "bottom",
            timeout: 15000,
          }
        );
        return new ValidationError("all", "");
      }
    );
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const deleteByKey = (data) => async (dispatch, getState, utils) => {
  const action = DELETE_OFFER_BY_KEY;

  try {
    return await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      deleteByKeyAPI,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
      (body) => {
        Alert.error(
          "Wystąpił błąd przy usuwaniu ogłoszenia! Spróbuj ponownie później lub skontaktuj się z nami pod adresem support@opiekujsie.pl",
          {
            position: "bottom",
            timeout: 15000,
          }
        );
        return new ValidationError("all", "");
      }
    );
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const clearError = (field) => ({
  type: OFFER_CLEAR_ERROR,
  payload: { field },
});

export const clearForm = (clearSentStatus) => ({
  type: OFFER_CLEAR_FORM,
  payload: { clearSentStatus },
});

export const generateSearchHash = () => ({
  type: GENERATE_OFFER_SEARCH_HASH,
});



/** WEBPACK FOOTER **
 ** ./src/common/offer/actions.js
 **/